import type { SVGProps } from "react";
export interface SackIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SackIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SackIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 15.5c0-2.124-1.068-4-2.24-5.405a14 14 0 0 0-1.59-1.62c-.168-.145-.315-.26-.428-.35H9.383c-.113.089-.26.204-.427.35-.435.376-1.014.927-1.591 1.62-1.171 1.405-2.24 3.28-2.24 5.405 0 1.864.806 3.155 2.026 4.02 1.262.893 3.015 1.354 4.848 1.355 1.834 0 3.589-.462 4.85-1.355 1.22-.865 2.026-2.156 2.026-4.02M11.91 3.125c-.278 0-.551.061-.8.179l-.24.136-.24.16a3.13 3.13 0 0 1-1.735.525h-.643l1.311 1.75h4.877l1.31-1.75h-.644c-.54 0-1.069-.14-1.537-.404l-.196-.121-.24-.16a1.88 1.88 0 0 0-1.04-.315zM21.125 15.5c0 2.636-1.195 4.594-2.975 5.855-1.738 1.231-3.984 1.77-6.15 1.77s-4.412-.539-6.15-1.77c-1.78-1.26-2.975-3.219-2.975-5.855 0-2.876 1.432-5.25 2.761-6.845a16.5 16.5 0 0 1 1.81-1.85L6.3 5.275c-1.05-1.4-.05-3.4 1.7-3.4h.894a.9.9 0 0 0 .486-.147l.24-.16.26-.16a4.1 4.1 0 0 1 2.029-.533h.183c.814 0 1.61.241 2.288.693l.24.16.113.064a.9.9 0 0 0 .372.083H16c1.696 0 2.688 1.876 1.793 3.267l-.094.133-1.148 1.53c.499.435 1.155 1.06 1.813 1.85 1.329 1.594 2.761 3.97 2.761 6.845"
      />
      <path
        fill={color}
        d="m11.297 12.778.004.051.002.006.003.003.007.01q.013.015.054.046c.134.097.401.21.854.3 1.238.247 2.732 1.106 2.732 2.83 0 1.231-.782 2.224-1.843 2.64a1.122 1.122 0 0 1-2.219.024 2.9 2.9 0 0 1-1.714-1.608l-.072-.193-.03-.112a1.124 1.124 0 0 1 2.122-.706l.043.107.03.075a.64.64 0 0 0 .187.218c.103.078.271.155.543.155.453 0 .703-.324.703-.6 0-.096-.028-.182-.148-.289a1.4 1.4 0 0 0-.514-.268l-.262-.067c-.563-.113-1.21-.304-1.736-.687-.584-.425-.997-1.076-.996-1.937q-.001-.053.004-.105l.002-.003c.046-1.16.853-1.984 1.837-2.342a1.124 1.124 0 0 1 2.218-.013c.84.298 1.427.921 1.715 1.608l.073.192.03.111a1.126 1.126 0 0 1-2.123.708l-.043-.107-.03-.075a.64.64 0 0 0-.187-.22c-.103-.077-.271-.155-.543-.155a.9.9 0 0 0-.573.185c-.113.094-.13.174-.13.213z"
      />
    </svg>
  );
}
